<template>
    <v-app id="app">
        <v-navigation-drawer
            v-model="drawer"
            app
            class="d-block d-md-none">
            <div class="d-flex align-center">
                <v-app-bar-nav-icon
                    @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            </div>

            <mobile-menu />
        </v-navigation-drawer>

        <v-app-bar
            height="64"
            class="d-flex"
            app>
            <v-app-bar-nav-icon
                class="d-block d-md-none"
                @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <div class="d-flex flex-grow-1 justify-center flex-md-grow-0 justify-md-start">
                <v-img
                    src="static/logo.png"
                    max-height="60"
                    max-width="193"
                    height="60"
                    width="193"
                    class="flex-grow-0"/>
            </div>

            <desktop-menu />
        </v-app-bar>

        <!-- Sizes your content based upon application components -->
        <v-main>

            <!-- Provides the application the proper gutter -->
            <v-container fluid>

                <!-- If using vue-router -->
                <router-view></router-view>
            </v-container>
        </v-main>

        <v-footer app>
            <!-- -->
        </v-footer>
    </v-app>
</template>

<script>
import MobileMenu from './components/layout/mobileMenu'
import DesktopMenu from './components/layout/desktopMenu'
export default {
    name: 'App',
    components: {DesktopMenu, MobileMenu},
    data () {
        return {
            drawer: false
        }
    }
}
</script>

<style lang="scss">
@import './assets/css/variables.scss';

body {
    background-color: $c-black !important;
}
#app {

    .v-app-bar__nav-icon .v-btn__content i:before {
        color: $c-white !important;
    }

    .v-navigation-drawer {
        .v-navigation-drawer__content > div:first-of-type {
            height: 56px !important;

            button {
                height: 48px !important;
                width: 48px !important;
                padding-left: 8px !important;
            }
        }
    }

    .v-app-bar {
        > .v-toolbar__content {
            width: 100% !important;
        }
    }

    .v-tooltip__content {
        background-color: $c-red !important;
        color: $c-white !important;
    }

    &.v-application .primary--text {
        color: $c-red !important;
        caret-color: $c-red !important;
    }
}
</style>

<style scoped lang="scss">
@import './assets/css/variables.scss';

#app {
    background-color: $c-black !important;

    .v-app-bar, .v-navigation-drawer {
        background-color: $c-red !important;
        color: $c-white !important;

        .v-toolbar__content > div:first-of-type {
            margin-right: 48px;
        }
    }
}

@media (min-width: 960px) {
    .v-application {
        max-width: 1440px !important;
        margin: auto !important;

        header, main {
            padding-left: 0 !important;
            left: 0 !important;
        }

        .v-toolbar .v-toolbar__content > div:first-of-type {
            margin-right: 0px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue